import ResourcesDispatcher from "../config/ResourcesDispatcher";
import Utils from "../utils/Utils";
export default class GameAnimations {
    static testMethod() {
        console.log("✅=^.^= GameAnimations library is connected successfully!");
    }
    //Il take event del gioco posso gestirlo tramite get e set
    static resetTakeEvent(getTakeEvent, setTakeEvent) {
        const currentEvent = getTakeEvent();
        if (currentEvent) {
            currentEvent.remove(false);
        }
        setTakeEvent(undefined);
    }
    /**
     * Tweens a numeric counter from `from` to `to`, updating `text` on every
     * frame via `Utils.formatValue`. Returns the created Tween so the
     * caller can stop/complete it at any time, and resolves the optional
     * Promise when the tween completes.
     *
     * @param scene    - The active Phaser scene (provides the tween manager)
     * @param text     - The Phaser Text object to update
     * @param from     - Starting value
     * @param to       - Target value
     * @param duration - Duration in milliseconds (default 1000)
     * @param onDone   - Optional callback invoked when the tween completes
     */
    static tweenCounter(text, from, to, loop = false, duration = 1000, onDone, onStartCallback, onUpdateCallback) {
        const tweenTarget = { value: from };
        let tweenConf = {
            targets: tweenTarget,
            value: { from, to },
            duration,
            ease: "Linear",
            repeat: loop ? -1 : 0,
            onStart: () => {
                onStartCallback?.();
            },
            onUpdate: () => {
                text.setText(Utils.formatValue(tweenTarget.value));
                onUpdateCallback?.();
            },
            onComplete: () => {
                text.setText(Utils.formatValue(to));
                onDone?.();
            }
        };
        return scene.tweens.add(tweenConf);
    }
    /**
    * Tweens a numeric counter from `from` to `to`, updating `text` on every
    * frame via `Utils.formatValue`. Returns the created Tween so the
    * caller can stop/complete it at any time, and resolves the optional
    * Promise when the tween completes.
    *
    * @param scene    - The active Phaser scene (provides the tween manager)
    * @param text     - The Phaser Text object to update
    * @param from     - Starting value
    * @param to       - Target value
    * @param duration - Duration in milliseconds (default 1000)
    * @param onDone   - Optional callback invoked when the tween completes
    */
    static tweenCounterSplitText(amountText, symbolText, from, to, duration = 1000, onDone, onUpdate) {
        const tweenTarget = { value: from };
        return scene.tweens.add({
            targets: tweenTarget,
            value: { from, to },
            duration,
            ease: "Linear",
            onStart: () => {
                let { symbol, value } = Utils.splitTextValueFromSymbol(Utils.formatValue(tweenTarget.value));
                amountText.setText(value);
                symbolText.setText(symbol || "");
            },
            onUpdate: () => {
                let { symbol, value } = Utils.splitTextValueFromSymbol(Utils.formatValue(tweenTarget.value));
                amountText.setText(value);
                onUpdate?.(amountText);
            },
            onComplete: () => {
                let { symbol, value } = Utils.splitTextValueFromSymbol(Utils.formatValue(to));
                amountText.setText(value);
                onDone?.();
            }
        });
    }
    static playWinningTween(tweenedValues, win, endScale, duration, winAmountText, soundToPlay, changeStateMachineCallback, getTakeEvent, setTakeEvent, onUpdateCallback) {
        return scene.tweens.add({
            targets: tweenedValues,
            value: win,
            scale: endScale,
            duration,
            ease: "Power1",
            onStart: () => {
                this.resetTakeEvent(getTakeEvent, setTakeEvent);
                winAmountText.setVisible(true);
                if (!gameLogicVariableManager.getTurbo()) {
                    soundManager.playCoinsSound();
                }
                else {
                    soundManager.play(soundToPlay);
                }
                changeStateMachineCallback();
            },
            onUpdate: () => {
                onUpdateCallback(tweenedValues);
            },
            onComplete: () => {
                animationManager.pointsToTweenOnCompleteFunction();
            }
        });
    }
    static async playWinCombinationAnimation(animatedCells, unanimatedCells, lineIndex, moreThanOneLine, startWinningCombinationsTextTween, stopWinningCombinationsTextTween) {
        // Mostra e anima le celle
        animatedCells.forEach((cell) => {
            cell.turnOn();
            cell.showFrame();
        });
        unanimatedCells.forEach((cell) => {
            cell.turnOff();
            cell.showFrame();
        });
        startWinningCombinationsTextTween(!moreThanOneLine, moreThanOneLine);
        if (moreThanOneLine) {
            await Promise.all(animatedCells.map((cell) => cell.playAnimation(false)));
            stopWinningCombinationsTextTween();
            animatedCells.forEach((cell) => {
                cell.turnOff();
                cell.hideFrame();
            });
            unanimatedCells.forEach((cell) => {
                cell.turnOff();
                cell.hideFrame();
            });
        }
        else {
            animatedCells.forEach((cell) => {
                cell.playAnimation(true);
            });
        }
    }
    // funzione che si occupa di ciclare le animazioni di vincita di qualunque combinazione
    static processWinningCellAnimation(reelIndex, cellIndex, animatedCells, unanimatedCells, cell, expanding) {
        if (cellIndex > 0) {
            const wildInfo = gameDataManager.getWildInfo()?.filter((wildInfo) => wildInfo.reelIndex === reelIndex);
            // caso in cui c'è l'extra wild che si espande
            if (wildInfo?.length > 0 && expanding) {
                animatedCells.push(expanding);
            }
            // caso in cui la cella extra wild si moltiplica
            else {
                animatedCells.push(cell);
            }
        }
        else {
            unanimatedCells.push(cell);
        }
    }
    static async animateAllSymbolsWithMemo(reels, memo) {
        const animatedCells = [];
        reels.forEach((reel) => {
            reel.cells.forEach((cell) => {
                if (cell.getMemo() === memo) {
                    animatedCells.push(cell);
                }
            });
        });
        await Promise.all(animatedCells.map((cell) => cell.playAnimation(false)));
    }
    static async animateAllSymbolsWithMemoList(reels, memos) {
        const animatedCells = [];
        reels.forEach((reel) => {
            reel.cells.forEach((cell) => {
                if (memos.includes(cell.getMemo())) {
                    animatedCells.push(cell);
                }
            });
        });
        await Promise.all(animatedCells.map((cell) => cell.playAnimation(false)));
    }
    static async animateWilds(reels, expanding) {
        const wildInfoList = gameDataManager.getWildInfo();
        const winningCombinations = gameDataManager.getWinningCombinations();
        if (!wildInfoList.length)
            return;
        const animations = wildInfoList.map((wildInfo) => {
            const { reelIndex, cellIndex } = wildInfo;
            const reelIsWinning = winningCombinations?.length > 0 && winningCombinations.some((combo) => combo.positions[reelIndex] > 0);
            // se è un expanding wild usa la gestione del wild che si espande, altrimenti usa la gestione delle celle animate con extra wild
            return expanding
                ? this.extraWildExpanding(reels, reelIndex, cellIndex, reelIsWinning)
                : this.extraWildInCells(reels, reelIndex, cellIndex, reelIsWinning);
        });
        await Promise.all(animations);
    }
    static extraWildExpanding(reels, reelIndex, cellIndex, reelIsWinning) {
        const expandingWild = reels[reelIndex].expandingWild;
        expandingWild.setIndex(cellIndex);
        expandingWild.expandWild(reelIsWinning);
    }
    static extraWildInCells(reels, reelIndex, cellIndex, reelIsWinning) {
        return new Promise((resolve) => {
            const cellsWithExtraWild = reels[reelIndex].getCells();
            const numCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
            const S_EXTRA_WILD = ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD;
            const wildImageInfo = ResourcesDispatcher.GAME_CONSTANTS.symbolImagesOn?.[S_EXTRA_WILD];
            // If the source cell is outside the visible range or we lack image info, fall back to instant show
            const sourceIsValid = cellIndex > 0 && cellIndex <= numCells && wildImageInfo;
            if (!sourceIsValid) {
                cellsWithExtraWild.forEach((ew, index) => {
                    if (index > 0 && index <= numCells) {
                        ew.setCellInfo(S_EXTRA_WILD);
                        ew.extraWildAnimation(reelIsWinning);
                    }
                });
                resolve();
                return;
            }
            // Show the wild immediately on the extraction cell
            const sourceCell = cellsWithExtraWild[cellIndex];
            sourceCell.setCellInfo(S_EXTRA_WILD);
            sourceCell.extraWildAnimation(reelIsWinning);
            // World position of the source image (used as starting point for the flying clones)
            const sourceWorldMatrix = sourceCell.getImage().getWorldTransformMatrix();
            const sourceX = sourceWorldMatrix.tx;
            const sourceY = sourceWorldMatrix.ty;
            const worldScale = sourceWorldMatrix.scaleX;
            // Collect promises for every flying clone so we can await them all
            const flyPromises = [];
            cellsWithExtraWild.forEach((ew, index) => {
                if (index <= 0 || index > numCells || index === cellIndex)
                    return;
                const targetWorldMatrix = ew.getImage().getWorldTransformMatrix();
                const targetX = targetWorldMatrix.tx;
                const targetY = targetWorldMatrix.ty;
                const distance = Math.abs(index - cellIndex);
                const flyingWild = scene.add.image(sourceX, sourceY, wildImageInfo.key, wildImageInfo.frame)
                    .setDepth(1000)
                    .setScale(worldScale);
                let alphatween;
                const flyPromise = new Promise((resolveFly) => {
                    scene.tweens.add({
                        targets: flyingWild,
                        x: targetX,
                        y: targetY,
                        duration: 450,
                        ease: 'Power2',
                        delay: (distance - 1) * 80,
                        onStart: () => {
                            // Immediately restore the original symbol on the target cell as the clone departs
                            alphatween = scene.tweens.add({
                                targets: ew.getImage(),
                                alpha: 0,
                                duration: 400 + ((distance - 1) * 60),
                                onComplete: () => {
                                    ew.getImage().setAlpha(1);
                                }
                            });
                        },
                        onComplete: () => {
                            alphatween?.complete();
                            alphatween?.remove();
                            flyingWild.destroy();
                            ew.setCellInfo(S_EXTRA_WILD);
                            ew.getImage().setAlpha(1);
                            ew.extraWildAnimation(reelIsWinning);
                            setTimeout(() => {
                                resolveFly();
                            }, 500); // Wait for the extra wild animation to finish before resolving
                        }
                    });
                });
                flyPromises.push(flyPromise);
            });
            Promise.all(flyPromises).then(() => resolve());
        });
    }
    static async collapseWilds(reels) {
        const wildInfoList = gameDataManager.getWildInfo();
        const flatGrid = gameDataManager.getGrid();
        if (!wildInfoList.length)
            return;
        const animations = wildInfoList.map((wildInfo) => {
            const { reelIndex, cellIndex } = wildInfo;
            const numCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
            // getGrid() returns a flat array (all reels concatenated); slice out the numCells
            // values belonging to this reel. Cell indices in the reel are 1-based (index 0 is
            // a hidden buffer), so reelMemos[index - 1] maps to the correct flat-array entry.
            const reelMemos = flatGrid.slice(reelIndex * numCells, (reelIndex + 1) * numCells);
            return new Promise((resolve) => {
                const cellsWithExtraWild = reels[reelIndex].getCells();
                const S_EXTRA_WILD = ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD;
                const wildImageInfo = ResourcesDispatcher.GAME_CONSTANTS.symbolImagesOn?.[S_EXTRA_WILD];
                const sourceIsValid = cellIndex > 0 && cellIndex <= numCells && wildImageInfo;
                if (!sourceIsValid) {
                    cellsWithExtraWild.forEach((ew, index) => {
                        if (index > 0 && index <= numCells) {
                            ew.setCellInfo(reelMemos[index - 1]);
                        }
                    });
                    resolve();
                    return;
                }
                const sourceCell = cellsWithExtraWild[cellIndex];
                const sourceWorldMatrix = sourceCell.getImage().getWorldTransformMatrix();
                const sourceX = sourceWorldMatrix.tx;
                const sourceY = sourceWorldMatrix.ty;
                const worldScale = sourceWorldMatrix.scaleX;
                const flyPromises = [];
                cellsWithExtraWild.forEach((ew, index) => {
                    if (index <= 0 || index > numCells || index === cellIndex)
                        return;
                    const startWorldMatrix = ew.getImage().getWorldTransformMatrix();
                    const startX = startWorldMatrix.tx;
                    const startY = startWorldMatrix.ty;
                    const distance = Math.abs(index - cellIndex);
                    const flyingWild = scene.add.image(startX, startY, wildImageInfo.key, wildImageInfo.frame)
                        .setDepth(1000)
                        .setScale(worldScale);
                    // Restore original symbol immediately as the clone departs
                    ew.setCellInfo(reelMemos[index - 1]);
                    const flyPromise = new Promise((resolveFly) => {
                        scene.tweens.add({
                            targets: flyingWild,
                            x: sourceX,
                            y: sourceY,
                            duration: 450,
                            ease: 'Power2',
                            delay: (distance - 1) * 80,
                            onComplete: () => {
                                flyingWild.destroy();
                                resolveFly();
                            }
                        });
                    });
                    flyPromises.push(flyPromise);
                });
                Promise.all(flyPromises).then(() => {
                    sourceCell.setCellInfo(reelMemos[cellIndex - 1]);
                    resolve();
                });
            });
        });
        await Promise.all(animations);
    }
    static async contractWilds(gameArea) {
        let expandingWilds = [];
        gameDataManager.getWildInfo().forEach((wildInfo) => {
            const expandingWild = gameArea.reels[wildInfo.reelIndex].expandingWild;
            expandingWild.setIndex(wildInfo.cellIndex);
            expandingWilds.push(expandingWild);
        });
        await Promise.all(expandingWilds.map((wild) => wild.contractWild()));
    }
    static async collapseFixedLinkReelsOnCollect(linkReels, collectReelIndex) {
        const S_COLLECT = ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT;
        //const S_COLLECT_COLLECTED = ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED;
        const numVisibleCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL;
        //È il collect
        //const collectInfo = this.getNewCollectLinkReelSymbolInfo(linkReels, S_COLLECT, numVisibleCells);
        const collectCell = linkReels[collectReelIndex].linkCells[1];
        const collectCellIndex = 1;
        if (!collectCell)
            return;
        collectCell.setCellInfo(S_COLLECT);
        const collectSpine = collectCell.getSpine(S_COLLECT);
        if (!collectSpine)
            return;
        const collectMatrix = collectSpine.getWorldTransformMatrix();
        const targetX = collectMatrix.tx;
        const targetY = collectMatrix.ty;
        const fixedReelsToReset = [];
        const animations = [];
        linkReels.forEach((reel, reelIndex) => {
            if (reelIndex === collectReelIndex)
                return;
            if (!reel.getIsFixedCell())
                return;
            fixedReelsToReset.push(reel);
            for (let cellIndex = 1; cellIndex <= numVisibleCells; cellIndex++) {
                const sourceCell = reel.linkCells[cellIndex];
                if (!sourceCell)
                    continue;
                const sourceMemo = sourceCell.getMemo();
                if (sourceMemo === undefined || sourceMemo === null || sourceMemo === 0)
                    continue;
                const sourceSpine = sourceCell.getSpine(sourceMemo);
                if (!sourceSpine)
                    continue;
                const sourceMatrix = sourceSpine.getWorldTransformMatrix();
                const flyingSpine = this.createFlyingLinkSpineFromMemo(sourceMemo, sourceSpine);
                if (!flyingSpine)
                    continue;
                flyingSpine.setPosition(sourceMatrix.tx, sourceMatrix.ty);
                flyingSpine.setScale(sourceMatrix.scaleX, sourceMatrix.scaleY);
                flyingSpine.setDepth(999999);
                flyingSpine.setAlpha(1);
                flyingSpine.setVisible(true);
                const distance = Math.abs(reelIndex - collectReelIndex) +
                    Math.abs(cellIndex - collectCellIndex);
                animations.push(new Promise((resolve) => {
                    scene.tweens.add({
                        targets: flyingSpine,
                        x: targetX,
                        y: targetY,
                        alpha: 0,
                        scaleX: sourceMatrix.scaleX * 0.25,
                        scaleY: sourceMatrix.scaleY * 0.25,
                        duration: 600,
                        ease: "Power2",
                        delay: Math.max(distance - 1, 0) * 80,
                        onComplete: () => {
                            flyingSpine.destroy();
                            resolve();
                        }
                    });
                }));
            }
        });
        await Promise.all(animations);
        await this.resetLinkGridAfterCollect(linkReels, collectReelIndex);
        return;
    }
    static async collapseFixedLinkValueTextsOnCollect(linkReels, collectReelIndex) {
        const numVisibleCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL;
        const collectCellIndex = 1;
        const collectCell = linkReels[collectReelIndex]?.linkCells[collectCellIndex];
        if (!collectCell)
            return;
        const collectValueText = collectCell.getLinkSpinWinText();
        const collectValueTextMatrix = collectValueText?.getWorldTransformMatrix();
        if (!collectValueTextMatrix)
            return;
        const targetX = collectValueTextMatrix.tx;
        const targetY = collectValueTextMatrix.ty;
        const animations = [];
        linkReels.forEach((reel, reelIndex) => {
            if (reelIndex === collectReelIndex)
                return;
            if (!reel.getIsFixedCell())
                return;
            for (let cellIndex = 1; cellIndex <= numVisibleCells; cellIndex++) {
                const sourceCell = reel.linkCells[cellIndex];
                if (!sourceCell)
                    continue;
                const sourceValueText = sourceCell.getLinkSpinWinText();
                const sourceText = sourceValueText?.text?.trim();
                let animation = "animation_exit";
                if (sourceCell.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_LINK || sourceCell.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED) {
                    animation = "animation_exit";
                }
                else if (sourceCell.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_MINI) {
                    animation = "mini_exit";
                }
                else if (sourceCell.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_MINOR) {
                    animation = "minor_exit";
                }
                else if (sourceCell.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR) {
                    animation = "major_exit";
                }
                sourceCell.getCurrentSpine()?.animationState.addAnimation(0, animation, false);
                // If value text is not set, skip this cell (including jackpots 13/14/15).
                if (!sourceText)
                    continue;
                const sourceValueMatrix = sourceValueText.getWorldTransformMatrix();
                const flyingText = this.createFlyingLinkValueText(sourceValueText, sourceText);
                if (!sourceValueMatrix || !flyingText)
                    continue;
                flyingText.setPosition(sourceValueMatrix.tx, sourceValueMatrix.ty);
                const distance = Math.abs(reelIndex - collectReelIndex) +
                    Math.abs(cellIndex - collectCellIndex);
                animations.push(new Promise((resolve) => {
                    scene.tweens.add({
                        targets: flyingText,
                        x: targetX,
                        y: targetY,
                        alpha: 0,
                        scaleX: flyingText.scaleX * 0.85,
                        scaleY: flyingText.scaleY * 0.85,
                        duration: 600,
                        ease: "Power2",
                        delay: Math.max(distance - 1, 0) * 80,
                        onComplete: () => {
                            flyingText.destroy();
                            soundManager.play(ResourcesDispatcher.SOUNDS.EXPLOSION_STONE);
                            resolve();
                        }
                    });
                }));
            }
        });
        await Promise.all(animations);
        await this.resetLinkGridAfterCollect(linkReels, collectReelIndex);
        return;
    }
    static async resetLinkGridAfterCollect(linkReels, collectReelIndex) {
        /**
         * Resetto i flag dei rulli.
         * Dopo li ripristino usando fixedReelIndexes.
         */
        linkReels.forEach((reel) => {
            reel.setIsFixedCell(false);
            reel.getCells().forEach((cell) => {
                cell.cleanLinkValueText();
                cell.linkSpinTextValueTween?.stop();
            });
        });
        /**
         * Il rullo del collect nuovo diventa anche collect reel.
         */
        const collectReel = linkReels[collectReelIndex];
        const realMult = gameDataManager.getLinkLastGridValues()[collectReelIndex];
        if (collectReel) {
            collectReel.setIsFixedCell(true);
            collectReel.linkCells[1].setCellInfo(ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED);
            collectReel.linkCells[1].setLinkSpinWinText(realMult);
            collectReel.linkCells[1].getLinkSpinWinText().setVisible(true);
        }
    }
    static resetAllLinkReel(linkReels) {
        linkReels.forEach((reel) => {
            reel.setIsFixedCell(false);
            reel.getCells().forEach((cell) => {
                cell.getLinkSpinWinText().setVisible(false);
            });
        });
    }
    static createFlyingLinkSpineFromMemo(sourceMemo, sourceSpine) {
        const spineRaw = ResourcesDispatcher.GAME_CONSTANTS.linkSymbolSpines?.[sourceMemo];
        if (!spineRaw) {
            console.warn("[collapseFixedLinkReelsOnCollect] Spine raw non trovato per memo:", sourceMemo);
            return null;
        }
        const flyingSpine = scene.add.spine(0, 0, spineRaw.jsonKey, spineRaw.atlasKey);
        flyingSpine.setOrigin(sourceSpine.originX ?? 0.5, sourceSpine.originY ?? 0.5);
        flyingSpine.setVisible(true);
        flyingSpine.setAlpha(1);
        flyingSpine.animationState.clearTracks();
        flyingSpine.skeleton.setToSetupPose();
        const currentAnimation = sourceSpine.animationState?.tracks?.[0]?.animation?.name;
        if (currentAnimation) {
            flyingSpine.animationState.setAnimation(0, currentAnimation, true);
        }
        else {
            const defaultAnimation = spineRaw.animations?.[0];
            if (defaultAnimation) {
                flyingSpine.animationState.setAnimation(0, defaultAnimation, true);
            }
        }
        return flyingSpine;
    }
    static createFlyingLinkValueText(sourceValueText, text) {
        if (!sourceValueText)
            return null;
        const sourceMatrix = sourceValueText.getWorldTransformMatrix();
        const flyingText = scene.add.text(sourceMatrix.tx, sourceMatrix.ty, text, sourceValueText.style);
        flyingText
            .setOrigin(sourceValueText.originX ?? 0.5, sourceValueText.originY ?? 0.5)
            .setScale(sourceMatrix.scaleX ?? sourceValueText.scaleX, sourceMatrix.scaleY ?? sourceValueText.scaleY)
            .setAlpha(sourceValueText.alpha ?? 1)
            .setDepth((sourceValueText.depth ?? 0) + 1000)
            .setVisible(true);
        return flyingText;
    }
    static playFreeSpinWinningAnimation(reels, numCell) {
        const animatedCells = [];
        reels.forEach((reel) => {
            for (let i = 1; i < numCell; i++) {
                animatedCells.push(reel.freeSpinCells[i]);
            }
        });
        animatedCells.forEach((cell) => cell.playAnimation(true));
    }
    static setWinningLines(combinations) {
        let winningLines = [];
        for (let i = 0; i < combinations.length; i++) {
            winningLines.push({
                symbolPositions: combinations[i].positions,
                index: combinations[i].numOfLine,
                repetitions: combinations[i].repeat,
                symbolIndex: combinations[i].symbol,
                win: combinations[i].win,
                animated: false,
                scatterLine: false
            });
        }
        return winningLines;
    }
    static stopWinCombinationAnimated(animatedCells) {
        animatedCells?.forEach((cell) => {
            cell.stopAnimation();
            cell.hideFrame();
            cell.turnOff();
        });
    }
    static stopWinCombinationUnanimated(unanimatedCells) {
        unanimatedCells?.forEach((cell) => {
            cell.hideFrame();
            cell.turnOff();
        });
    }
    //Tasto per skippare le animazioni di ingresso nelle scene bonus
    static playEntryToBonusSceneSpineAnimation(type) {
        return new Promise((resolve) => {
            // let skipText = document.createElement('div');
            // skipText.textContent = 'CLICK OR TAP TO SKIP';
            // skipText.style.cssText = [
            //     'position:fixed',
            //     'bottom:20px',
            //     'left:50%',
            //     'transform:translateX(-50%)',
            //     'color:white',
            //     'font-size:16px',
            //     'font-family:sans-serif',
            //     'letter-spacing:2px',
            //     'z-index:9999',
            //     'display:none',
            //     'pointer-events:none',
            //     'white-space:nowrap',
            //     'text-shadow:0 0 6px #000,0 0 6px #000'
            // ].join(';');
            // document.body.appendChild(skipText);
            let spineName;
            let spineNamePortrait;
            const orientation = generalManager.getOrientation();
            switch (type) {
                case "freespin":
                    soundManager.play(ResourcesDispatcher.SOUNDS.ENTER_BONUS);
                    scene.setBackgroundImage(ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME); //per il freespin
                    window.isFreeSpinEntryPlaying = true;
                    spineName = ResourcesDispatcher.SPINES.FreeSpin_Entry;
                    spineNamePortrait = ResourcesDispatcher.SPINES.FreeSpin_Entry_pt;
                    break;
                case "pickbonus":
                    soundManager.play(ResourcesDispatcher.SOUNDS.ENTER_BONUS);
                    scene.setBackgroundImage(ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.PICKBONUS);
                    window.isPickBonusPlaying = true;
                    spineName = ResourcesDispatcher.SPINES.PickBonus_Entry;
                    spineNamePortrait = ResourcesDispatcher.SPINES.PickBonus_Entry_pt;
                    break;
                case "linkspin":
                    soundManager.play(ResourcesDispatcher.SOUNDS.ENTER_BONUS);
                    scene.setBackgroundImage(ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.LINKSPIN);
                    window.isLinkSpinEntryPlaying = true;
                    spineName = ResourcesDispatcher.SPINES.LinkSpin_Entry;
                    spineNamePortrait = ResourcesDispatcher.SPINES.LinkSpin_Entry_pt;
                    break;
                default:
                    break;
            }
            this.spine = scene.add.spine(scene.scale.width / 2, scene.scale.height / 2, spineName.jsonKey, spineName.atlasKey);
            this.spinePortrait = scene.add.spine(scene.scale.width / 2, scene.scale.height / 2, spineNamePortrait.jsonKey, spineNamePortrait.atlasKey);
            this.spine.animationState.setAnimation(0, "animation", false);
            this.spinePortrait.animationState.setAnimation(0, "animation", false);
            if (orientation === "portrait") {
                this.spine.setVisible(false);
                this.spinePortrait.setVisible(true);
            }
            else {
                this.spine.setVisible(true);
                this.spinePortrait.setVisible(false);
            }
            //  skipText.style.display = 'block';
            // if(generalManager.getOrientation() === "portrait"){
            //     skipText.style.fontSize = '15px';
            // }
            const finish = () => {
                scene.input.off("pointerdown", onSkip);
                scene.input.keyboard?.off("keydown-SPACE", onSkip);
                this.spine.animationState.removeListener(completeListener);
                this.spine.destroy();
                this.spinePortrait.animationState.removeListener(completeListenerPortrait);
                this.spinePortrait.destroy();
                //skipText.style.display = 'none';
                // if(type === "freespin")
                //     (window as any).isFreeSpinEntryPlaying = false;
                // else if(type === "pickbonus")
                //     (window as any).isPickBonusPlaying = false;
                // else if(type === "linkspin")
                //     (window as any).isLinkSpinEntryPlaying = false;
                window.dispatchEvent(new Event("resize"));
                resolve();
            };
            const onSkip = () => finish();
            let loopCount = 0;
            const completeListener = {
                complete: () => {
                    loopCount++;
                    if (loopCount < 1)
                        return;
                    finish();
                }
            };
            const completeListenerPortrait = {
                complete: () => {
                    loopCount++;
                    if (loopCount < 1)
                        return;
                    finish();
                }
            };
            this.spine.animationState.addListener(completeListener);
            this.spinePortrait.animationState.addListener(completeListenerPortrait);
            scene.input.once("pointerdown", onSkip);
            scene.input.keyboard?.once("keydown-SPACE", onSkip);
        });
    }
    static setVisibleSpineEntry(spine, spinePortrait) {
        spine.setPosition(scene.scale.width / 2, scene.scale.height / 2);
        spinePortrait.setPosition(scene.scale.width / 2, scene.scale.height / 2);
        if (generalManager.getOrientation() === "portrait") {
            spine.setVisible(false);
            spinePortrait.setVisible(true);
        }
        else {
            spine.setVisible(true);
            spinePortrait.setVisible(false);
        }
    }
}
